  
<template>
  <section id="authentification" class="columns is-multiline is-mobile">
    <div
      id="Se connecter"
      class="column is-4-desktop is-offset-1-desktop is-10-mobile is-offset-1-mobile borderRight is-center"
    >
      <form @submit.prevent id="form-login">
        <h2 class="title">Se connecter</h2>

        <b-field label="Email">
          <b-input
            type="email"
            placeholder="Votre email"
            maxlength="30"
            v-model.trim="email_login"
            id="email-login"
          ></b-input>
        </b-field>

        <b-field label="Mot de passe">
          <b-input
            type="password"
            placeholder="Mot de passe"
            id="password-login"
            v-model.trim="password_login"
            password-reveal
          ></b-input>
        </b-field>
        <vue-recaptcha
          sitekey="6LczisgZAAAAAD26jyCmxENQ0hgxKkOZD7IYQa_M"
          @verify="verifyRecaptchaLogin"
        ></vue-recaptcha>
        <div class="buttons">
          <b-button
            type="is-success"
            @click="login"
            :loading="envoieEnCours"
            :disabled="envoieEnCours"
            >Connexion</b-button
          >
          <b-button type="is-info" @click="recupMotDePasse"
            >Mot de passe oublié ?</b-button
          >
        </div>

        <br />
        <span v-if="incorrect" id="incorrect" style="color: red"
          >Email ou Mot de passe incorrect.</span
        >
        <span v-if="connexionError" id="inscriptionError" style="color: red">{{
          connexionErrorMessage
        }}</span>
      </form>
    </div>
    <div
      id="register"
      class="column is-4-desktop is-offset-1-desktop is-10-mobile is-offset-1-mobile"
    >
      <form @submit.prevent id="form-register">
        <h2 class="title">S'inscrire</h2>

        <b-field label="Email">
          <b-input
            type="email"
            placeholder="Votre email"
            maxlength="30"
            v-model.trim="email_register"
            id="email-register"
          ></b-input>
        </b-field>

        <b-field label="Mot de passe">
          <b-input
            type="password"
            placeholder="Mot de passe"
            id="password-register"
            v-model.trim="password_register"
            password-reveal
          ></b-input>
        </b-field>
        <b-field label="Confirmer mot de passe">
          <b-input
            type="password"
            placeholder="Mot de passe"
            id="password-verification"
            v-model.trim="password_verification"
            password-reveal
          ></b-input>
        </b-field>
        <vue-recaptcha
          sitekey="6LczisgZAAAAAD26jyCmxENQ0hgxKkOZD7IYQa_M"
          @verify="verifyRecaptchaRegister"
        ></vue-recaptcha>

        <b-button
          @click="register"
          type="is-success"
          :loading="envoieEnCours"
          :disabled="envoieEnCours"
          >Inscription</b-button
        >
        <span
          v-if="inscriptionError"
          id="inscriptionError"
          style="color: red"
          >{{ inscriptionErrorMessage }}</span
        >
      </form>
    </div>
  </section>
</template>

<script>
const firebase = require("../firebase.js");
import { db } from "@/firebase";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "Authentification",
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      recaptcha_login: null,
      recaptcha_register: null,
      email_login: "",
      password_login: "",
      email_register: "",
      password_register: "",
      password_verification: "",
      incorrect: false,
      inscriptionError: false,
      inscriptionErrorMessage: "",
      connexionError: false,
      connexionErrorMessage: "",
      envoieEnCours: false,
    };
  },
  methods: {
    verifyRecaptchaLogin(response) {
      this.recaptcha_login = response;
    },
    verifyRecaptchaRegister(response) {
      this.recaptcha_register = response;
    },
    login() {
      if (!this.recaptcha_login) {
        this.connexionError = true;
        this.connexionErrorMessage = "Veuillez valider le reCaptcha";
        return;
      }
      this.envoieEnCours = true;
      firebase.auth
        .signInWithEmailAndPassword(this.email_login, this.password_login)
        .then((user) => {
          this.envoieEnCours = false;
          this.$store.commit("setCurrentUser", user);
          this.$router.push("/");
        })
        .catch(() => {
          this.incorrect = true;
          this.envoieEnCours = false;
        });
    },
    recupMotDePasse() {
      this.$buefy.dialog.prompt({
        type: "is-info",
        title: "Mot de passe oublié",
        message: `Veuillez saisir votre e-mail et nous vous enverrons un e-mail contenant les instructions de réinitialisation du mot de passe. <br/> Pensez à vérifier vos courrier indésirable.`,
        inputAttrs: {
          placeholder: "exemple@email.fr",
          maxlength: 35,
          type: "is-warning",
        },
        size: "is-medium",
        trapFocus: true,
        cancelText: "Retour",
        confirmText: "Envoyer l'email",
        onConfirm: async (emailAddress) => {
          const auth = firebase.auth;
          try {
            await auth.sendPasswordResetEmail(emailAddress);
            this.$buefy.toast.open(
              `L'e-mail a bien été envoyé à : ${emailAddress}`
            );
          } catch (error) {
            console.log(error);
          }
        },
      });
    },
    register() {
      if (this.password_register !== this.password_verification) {
        this.inscriptionError = true;
        this.inscriptionErrorMessage =
          "Erreur vos mots de passe ne sont pas les même.";
        return;
      }
      if (!this.recaptcha_register) {
        this.inscriptionError = true;
        this.inscriptionErrorMessage = "Veuillez valider le reCaptcha";
        return;
      }
      this.envoieEnCours = true;
      firebase.auth
        .createUserWithEmailAndPassword(
          this.email_register,
          this.password_register
        )
        .then(async (user) => {
          this.$store.commit("setCurrentUser", user);
          db.collection("profiles")
            .doc(await user.user.uid)
            .set({
              lastName: "",
              firstName: "",
              mail: this.email_register,
              tel: "",
              fullAddress: {
                address: "",
                postalCode: "",
                city: "",
                country: "",
              },
            })
            .then(() => {
              this.envoieEnCours = false;
              user.user.sendEmailVerification();
              this.$buefy.dialog.confirm({
                title: "Création de compte réussis.",
                message:
                  "Vous allez recevoir un email de confirmation. <br/> Pensez à vérifier dans vos courrier indésirable.",
                type: "is-info",
                hasIcon: true,
                icon: "info-circle",
                ariaRole: "alertdialog",
                ariaModal: true,
                confirmText: "Ok",
                onConfirm: () => {
                  this.$router.push("/");
                },
              });
            })
            .catch((err) => {
              console.log(err);
              this.$buefy.dialog.alert({
                title: "Erreur",
                message: "Si le problème persiste, veuillez nous contacter.s",
                type: "is-danger",
                hasIcon: true,
                icon: "frown",
                ariaRole: "alertdialog",
                ariaModal: true,
              });
              this.envoieEnCours = false;
            });
        })
        .catch((err) => {
          this.envoieEnCours = false;
          if (err.code === "auth/email-already-in-use") {
            this.inscriptionError = true;
            this.inscriptionErrorMessage = "Cet email est déjà utilisé.";
          } else {
            this.inscriptionError = true;
            this.inscriptionErrorMessage =
              "Le mot de passe doit faire au moins 6 caractères.";
          }
        });
    },
  },
};
</script>